import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys.js'
import CacheManager from '../../../cache/CacheManager.js'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'
import ConditionSubsequentRemarksPageUI from './ConditionSubsequentRemarksPageUI.js'

class ConditionSubsequentRemarksPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      accountRemarkList: null
    }
  }

  render() {
    return (
      <ConditionSubsequentRemarksPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        accountRemarkList={this.state.accountRemarkList}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getRemarks(context)
  }

  getRemarks(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/objectCode/cs/remarks`,
      cacheKey: CacheKeys.AllRemarks(),
      callback: this.getRemarksCallback,
      ttlInSecs: 60
    })
    cacheManager.getObject2(context)
  }

  getRemarksCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      accountRemarkList: response.accountRemarkList
    })
  }

  onRefreshClick = () => {
    CacheManager.removeObject(CacheKeys.AllRemarks())
    this.setState({ accountRemarkList: null, errorList: null }, () => {
      this.getRemarks(this.props.context)
    })
  }

}

export default withRouter(ConditionSubsequentRemarksPageSF)
